import React, { useEffect, useRef, useState } from "react";
import Styles from "../../styles/gym/creategym.module.scss";
import Navbar from "../../components/Navbar";
import "../../styles/session/quill-custom.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { adminRoutes } from "../../routers/AdminRouters";
import { addGym, editGym, getGymById, getOptions } from "../../services";
import Close_Button from "../../assets/auth/close.png";
import Suceess from "../../assets/session/success.png";
import Copy from "../../assets/gym/copy-01.png";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { toggle } from "../../redux";
import pass_on from "../../assets/auth/pass-on.png";
import pass_off from "../../assets/auth/pass-off.png";
const EditGym = () => {
  const gymnameRef = useRef();
  const usernameRef = useRef();
  const locationRef = useRef();
  const passwordRef = useRef();
  const phoneRef = useRef();
  const { options } = useSelector((state) => state.exercises);
  const isSidebarOpen = useSelector((state) => state.navbar.button);
  const { gym } = useSelector((state) => state.gym);
  const { gymId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };
  useEffect(() => {
    getOptions();
  }, []);

  useEffect(() => {
    const fetchGymData = async () => {
      try {
        const response = await getGymById(gymId);

        if (response) {
          gymnameRef.current.value = response.name || "";
          locationRef.current.value = response.location || "";
          usernameRef.current.value = response.username || "";
          phoneRef.current.value = response.phone || "";
        }
      } catch (error) {
        console.error("Error fetching gym details:", error);
      }
    };

    if (gymId) {
      fetchGymData();
    }
  }, [gymId]);

  const handleSubmit = async () => {
    try {
      const newPassword = passwordRef.current.value;
      const gymData = {
        name: gymnameRef.current.value,
        location: locationRef.current.value,
        phone: phoneRef.current.value,
        username: usernameRef.current.value,
        password: newPassword,
      };

      const originalGym = await getGymById(gymId);
      const originalPassword = originalGym?.password || "";

      const passwordChanged = newPassword && newPassword !== originalPassword;

      const success = await editGym(gymId, gymData);

      if (success) {
        let swalContent = `
          <div style="text-align: center; padding: 20px;">
            <button id="customCloseButton" style="position: absolute; top: 10px; right: 10px; background: none; border: none; cursor: pointer;">
              <img src=${Close_Button} alt="Close" style="width: 20px; height: 20px;" />
            </button>
            <img src=${Suceess} alt="Success" style="width: 80px; height: 80px; margin-bottom: 20px;" />
            <h2 style="margin: 0;">Gym updated successfully</h2>
            <p>Save credentials for later</p>
            <div style="background: #f9f9f9; padding: 15px; border-radius: 8px; text-align: left;">
              <div style="display: flex; justify-content: space-between; margin-bottom: 8px;">
                <span>Username ID:</span>
                <span style="color: #f79328;">${gymData.username}</span>
                <img id="copyUsername" src=${Copy} alt="Copy" style="cursor: pointer;" />
              </div>
        `;

        if (passwordChanged) {
          swalContent += `
            <div style="display: flex; justify-content: space-between;">
              <span>Password:</span>
              <span style="color: #f79328;">${gymData.password}</span>
              <img id="copyPassword" src=${Copy} alt="Copy" style="cursor: pointer;" />
            </div>
          `;
        }

        swalContent += `</div>
          <button id="closeButton" style="background: #f79328; color: #f3f3f6; padding: 10px 30px; border: none; border-radius: 8px; margin-top: 15px; cursor: pointer;">
            Close
          </button>
        </div>`;

        Swal.fire({
          html: swalContent,
          showConfirmButton: false,
          allowOutsideClick: false,
          customClass: {
            popup: "custom-swal-container",
          },
          didOpen: () => {
            const copyToClipboard = (text, element) => {
              navigator.clipboard
                .writeText(text)
                .then(() => {
                  const swalPopup = Swal.getPopup();
                  if (swalPopup) {
                    const originalText = element.alt;
                    element.alt = "Copied!";
                    element.style.opacity = "0.5";

                    setTimeout(() => {
                      element.alt = originalText;
                      element.style.opacity = "1";
                    }, 1500);
                  }
                })
                .catch(() => {
                  Swal.fire({
                    text: "Failed to copy!",
                    icon: "error",
                    timer: 1500,
                    showConfirmButton: false,
                  });
                });
            };

            document
              .getElementById("copyUsername")
              ?.addEventListener("click", (e) => {
                e.stopPropagation();
                copyToClipboard(gymData.username, e.target);
              });

            if (passwordChanged) {
              document
                .getElementById("copyPassword")
                ?.addEventListener("click", (e) => {
                  e.stopPropagation();
                  copyToClipboard(gymData.password, e.target);
                });
            }

            document
              .getElementById("closeButton")
              ?.addEventListener("click", () => {
                navigate(adminRoutes.listGym);
                Swal.close();
              });

            document
              .getElementById("customCloseButton")
              ?.addEventListener("click", () => {
                navigate(adminRoutes.listGym);
                Swal.close();
              });
          },
        });
      }
    } catch (error) {
      console.error("Error updating gym:", error);
    }
  };

  const handleBack = () => {
    navigate(adminRoutes.listGym);
  };

  return (
    <>
      <Navbar />
      <div
        className={Styles.createsession_main}
        onClick={handleMainContainerClick}
      >
        <h2>
          <Link to={adminRoutes.listGym} className={Styles.dark}>
            HOME
          </Link>
          <span className={Styles.orange}> / EDIT GYM</span>
        </h2>
        <div className={Styles.createsession_container}>
          <div className={Styles.createsession}>
            <div className={Styles.createsession_container_heading}>
              <h3>EDIT GYM</h3>
            </div>
            <hr />
            <div className={Styles.createsession_form_container}>
              <form>
                <div className={Styles.createsession_form}>
                  <div className={Styles.createsession_form_containerboxone}>
                    <div
                      className={Styles.createsession_form_containerboxchildone}
                    >
                      <div className={Styles.createsession_form_containerone}>
                        <label className={Styles.label}>Gym Name</label>
                        <input
                          placeholder="Enter here"
                          required
                          type="text"
                          ref={gymnameRef}
                        />
                      </div>
                      <div className={Styles.createsession_form_containertwo}>
                        <div className={Styles.input_group}>
                          <label className={Styles.label}>Locations</label>
                          <select ref={locationRef}>
                            <option value="" disabled selected>
                              Choose from list
                            </option>
                            {(options?.locations || []).map((item, index) => (
                              <option key={index} value={item}>
                                {item}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={Styles.createsession_form_containerright}>
                  <div
                    className={Styles.createsession_form_containerrightchild}
                  >
                    <label className={Styles.label}>Username</label>
                    <input
                      placeholder="Enter here"
                      type="username"
                      ref={usernameRef}
                      required
                    />
                  </div>
                  <div
                    className={Styles.createsession_form_containerrightchild}
                  >
                    <label className={Styles.label}>Phone Number</label>
                    <input
                      placeholder="Enter here"
                      type="text"
                      name="phone"
                      ref={phoneRef}
                      maxLength={10}
                      onChange={(e) => {
                        let value = e.target.value.replace(/[^\d]/g, "");
                        if (value.length > 10) {
                          value = value.slice(0, 10);
                        }
                        phoneRef.current.value = value;
                      }}
                      required
                    />
                  </div>
                  <div
                    className={Styles.createsession_form_containerrightchild}
                  >
                    <label className={Styles.label}>Enter Password</label>
                    <input
                      placeholder="Enter here"
                      type={showPassword ? "text" : "password"}
                      name="password"
                      minLength={2}
                      maxLength={50}
                      ref={passwordRef}
                      required
                    />
                  </div>
                  <div
                    type="button"
                    onClick={togglePasswordVisibility}
                    className={Styles.eyeIcon}
                  >
                    <img
                      src={showPassword ? pass_on : pass_off}
                      alt="Toggle password visibility"
                      className={Styles.eyeImage}
                    />
                  </div>
                </div>
              </form>
            </div>
            <hr />
            <div className={Styles.button_container}>
              <div
                className={Styles.save}
                onClick={handleSubmit}
                style={{ cursor: "pointer" }}
              >
                Save
              </div>
              <div
                className={Styles.cancel}
                onClick={handleBack}
                style={{ cursor: "pointer" }}
              >
                Cancel
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditGym;
